export const HTTP = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403
}